
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "AccountNotification": [
      "AddInvestingEntityNotification",
      "ConfirmEmailAddressNotification",
      "ConfirmIdentityDocumentDetailsNotification",
      "ProvideCityOfBirthNotification",
      "ReattemptVerifyAddressNotification",
      "ReattemptVerifyBiometricIdentityNotification",
      "VerifyAddressNotification",
      "VerifyBiometricIdentityNotification",
      "VerifyIdentityNotification"
    ],
    "Accreditation": [
      "RetailOnlyAccreditation",
      "WholesaleAccreditation"
    ],
    "AdviserProfileRegistrationData": [
      "AdviserProfileAustralianRegistration"
    ],
    "AllocationAdviserFeeValue": [
      "AllocationDollarAdviserFee",
      "AllocationPercentAdviserFee"
    ],
    "AllocationRequestedValue": [
      "FixedPointNumber",
      "HighPrecisionMoney"
    ],
    "BankAccountLocationDetails": [
      "AUDBankAccountBankAccountLocationDetails",
      "GBPBankAccountBankAccountLocationDetails",
      "USDBankAccountBankAccountLocationDetails"
    ],
    "BulkCreateAllocationRequestPayload": [
      "BulkCreateAllocationRequestFailureResult",
      "BulkCreateAllocationRequestSuccessResult"
    ],
    "CustomField": [
      "CustomFieldCheckboxes",
      "CustomFieldContent",
      "CustomFieldDocumentUpload",
      "CustomFieldMultiSelect",
      "CustomFieldRadios",
      "CustomFieldSelect",
      "CustomFieldText"
    ],
    "CustomFieldBase": [
      "CustomFieldCheckboxes",
      "CustomFieldContent",
      "CustomFieldDocumentUpload",
      "CustomFieldMultiSelect",
      "CustomFieldRadios",
      "CustomFieldSelect",
      "CustomFieldText"
    ],
    "CustomFieldInputBase": [
      "CustomFieldCheckboxes",
      "CustomFieldDocumentUpload",
      "CustomFieldMultiSelect",
      "CustomFieldRadios",
      "CustomFieldSelect",
      "CustomFieldText"
    ],
    "Entity": [
      "CompanyInvestingEntity",
      "IndividualInvestingEntity",
      "JointIndividualInvestingEntity",
      "PartnershipInvestingEntity",
      "TrustInvestingEntity"
    ],
    "InvestingEntityNotification": [
      "AddBankAccountNotification",
      "ConfirmAccreditationNotification",
      "ConfirmUnsupportedCountryAccreditationNotification",
      "ProvideBeneficialOwnerContactDetailsNotification",
      "ProvideInvestingEntityDocumentsNotification",
      "ProvideSourceOfFundsNotification",
      "ReattemptConfirmAccreditationNotification",
      "ReattemptProvideSourceOfFundsNotification",
      "RenewAccreditationNotification",
      "VerifyBankAccountNotification"
    ],
    "MaybeVerifiableBankAccount": [
      "AUDVerifiableBankAccount",
      "BankAccount",
      "EURVerifiableBankAccount",
      "GBPVerifiableBankAccount",
      "NZDVerifiableBankAccount",
      "USDVerifiableBankAccount"
    ],
    "MoneyAccount": [
      "AUDVerifiableBankAccount",
      "BankAccount",
      "EURVerifiableBankAccount",
      "GBPVerifiableBankAccount",
      "NZDVerifiableBankAccount",
      "USDVerifiableBankAccount"
    ],
    "Notification": [
      "AddBankAccountNotification",
      "AddInvestingEntityNotification",
      "ConfirmAccreditationNotification",
      "ConfirmEmailAddressNotification",
      "ConfirmIdentityDocumentDetailsNotification",
      "ConfirmUnsupportedCountryAccreditationNotification",
      "ProvideBeneficialOwnerContactDetailsNotification",
      "ProvideCityOfBirthNotification",
      "ProvideInvestingEntityDocumentsNotification",
      "ProvideSourceOfFundsNotification",
      "ReattemptConfirmAccreditationNotification",
      "ReattemptProvideSourceOfFundsNotification",
      "ReattemptVerifyAddressNotification",
      "ReattemptVerifyBiometricIdentityNotification",
      "RenewAccreditationNotification",
      "VerifyAddressNotification",
      "VerifyBankAccountNotification",
      "VerifyBiometricIdentityNotification",
      "VerifyIdentityNotification"
    ],
    "OfferDataBlock": [
      "OfferTableBlock",
      "OfferTextBlock"
    ],
    "OrderRequestedValue": [
      "OrderDollarsRequestedValue",
      "OrderPercentageRequestedValue",
      "OrderUnitsRequestedValue"
    ],
    "PortfolioOrder": [
      "AllocationRequest",
      "BuyOrder",
      "SellOrder",
      "UnitRedemptionRequest",
      "UnitTransferRequest"
    ],
    "Transaction": [
      "AutoReInvestmentTransaction",
      "DepositTransaction",
      "DistributionPaymentTransaction",
      "DistributionTransaction",
      "FundExitTransaction",
      "NewInvestmentTransaction",
      "OffMarketTransferTransaction",
      "RedemptionTransaction",
      "SecondaryUnitPurchaseTransaction",
      "SecondaryUnitSaleTransaction",
      "TaxAttributionTransaction",
      "WithdrawalTransaction"
    ],
    "VerifiableBankAccount": [
      "AUDVerifiableBankAccount",
      "EURVerifiableBankAccount",
      "GBPVerifiableBankAccount",
      "NZDVerifiableBankAccount",
      "USDVerifiableBankAccount",
      "VerifiableBankAccountImpl"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AccountNotification": [
      "AddInvestingEntityNotification",
      "ConfirmEmailAddressNotification",
      "ConfirmIdentityDocumentDetailsNotification",
      "ProvideCityOfBirthNotification",
      "ReattemptVerifyAddressNotification",
      "ReattemptVerifyBiometricIdentityNotification",
      "VerifyAddressNotification",
      "VerifyBiometricIdentityNotification",
      "VerifyIdentityNotification"
    ],
    "Accreditation": [
      "RetailOnlyAccreditation",
      "WholesaleAccreditation"
    ],
    "AdviserProfileRegistrationData": [
      "AdviserProfileAustralianRegistration"
    ],
    "AllocationAdviserFeeValue": [
      "AllocationDollarAdviserFee",
      "AllocationPercentAdviserFee"
    ],
    "AllocationRequestedValue": [
      "FixedPointNumber",
      "HighPrecisionMoney"
    ],
    "BankAccountLocationDetails": [
      "AUDBankAccountBankAccountLocationDetails",
      "GBPBankAccountBankAccountLocationDetails",
      "USDBankAccountBankAccountLocationDetails"
    ],
    "BulkCreateAllocationRequestPayload": [
      "BulkCreateAllocationRequestFailureResult",
      "BulkCreateAllocationRequestSuccessResult"
    ],
    "CustomField": [
      "CustomFieldCheckboxes",
      "CustomFieldContent",
      "CustomFieldDocumentUpload",
      "CustomFieldMultiSelect",
      "CustomFieldRadios",
      "CustomFieldSelect",
      "CustomFieldText"
    ],
    "CustomFieldBase": [
      "CustomFieldCheckboxes",
      "CustomFieldContent",
      "CustomFieldDocumentUpload",
      "CustomFieldMultiSelect",
      "CustomFieldRadios",
      "CustomFieldSelect",
      "CustomFieldText"
    ],
    "CustomFieldInputBase": [
      "CustomFieldCheckboxes",
      "CustomFieldDocumentUpload",
      "CustomFieldMultiSelect",
      "CustomFieldRadios",
      "CustomFieldSelect",
      "CustomFieldText"
    ],
    "Entity": [
      "CompanyInvestingEntity",
      "IndividualInvestingEntity",
      "JointIndividualInvestingEntity",
      "PartnershipInvestingEntity",
      "TrustInvestingEntity"
    ],
    "InvestingEntityNotification": [
      "AddBankAccountNotification",
      "ConfirmAccreditationNotification",
      "ConfirmUnsupportedCountryAccreditationNotification",
      "ProvideBeneficialOwnerContactDetailsNotification",
      "ProvideInvestingEntityDocumentsNotification",
      "ProvideSourceOfFundsNotification",
      "ReattemptConfirmAccreditationNotification",
      "ReattemptProvideSourceOfFundsNotification",
      "RenewAccreditationNotification",
      "VerifyBankAccountNotification"
    ],
    "MaybeVerifiableBankAccount": [
      "AUDVerifiableBankAccount",
      "BankAccount",
      "EURVerifiableBankAccount",
      "GBPVerifiableBankAccount",
      "NZDVerifiableBankAccount",
      "USDVerifiableBankAccount"
    ],
    "MoneyAccount": [
      "AUDVerifiableBankAccount",
      "BankAccount",
      "EURVerifiableBankAccount",
      "GBPVerifiableBankAccount",
      "NZDVerifiableBankAccount",
      "USDVerifiableBankAccount"
    ],
    "Notification": [
      "AddBankAccountNotification",
      "AddInvestingEntityNotification",
      "ConfirmAccreditationNotification",
      "ConfirmEmailAddressNotification",
      "ConfirmIdentityDocumentDetailsNotification",
      "ConfirmUnsupportedCountryAccreditationNotification",
      "ProvideBeneficialOwnerContactDetailsNotification",
      "ProvideCityOfBirthNotification",
      "ProvideInvestingEntityDocumentsNotification",
      "ProvideSourceOfFundsNotification",
      "ReattemptConfirmAccreditationNotification",
      "ReattemptProvideSourceOfFundsNotification",
      "ReattemptVerifyAddressNotification",
      "ReattemptVerifyBiometricIdentityNotification",
      "RenewAccreditationNotification",
      "VerifyAddressNotification",
      "VerifyBankAccountNotification",
      "VerifyBiometricIdentityNotification",
      "VerifyIdentityNotification"
    ],
    "OfferDataBlock": [
      "OfferTableBlock",
      "OfferTextBlock"
    ],
    "OrderRequestedValue": [
      "OrderDollarsRequestedValue",
      "OrderPercentageRequestedValue",
      "OrderUnitsRequestedValue"
    ],
    "PortfolioOrder": [
      "AllocationRequest",
      "BuyOrder",
      "SellOrder",
      "UnitRedemptionRequest",
      "UnitTransferRequest"
    ],
    "Transaction": [
      "AutoReInvestmentTransaction",
      "DepositTransaction",
      "DistributionPaymentTransaction",
      "DistributionTransaction",
      "FundExitTransaction",
      "NewInvestmentTransaction",
      "OffMarketTransferTransaction",
      "RedemptionTransaction",
      "SecondaryUnitPurchaseTransaction",
      "SecondaryUnitSaleTransaction",
      "TaxAttributionTransaction",
      "WithdrawalTransaction"
    ],
    "VerifiableBankAccount": [
      "AUDVerifiableBankAccount",
      "EURVerifiableBankAccount",
      "GBPVerifiableBankAccount",
      "NZDVerifiableBankAccount",
      "USDVerifiableBankAccount",
      "VerifiableBankAccountImpl"
    ]
  }
};
      export default result;
    